export enum AppRole {
  SuperAdmin = "SuperAdmin",
  Admin = "Admin",
  RegisteredUser = "RegisteredUser",
  OrganizationOwner = "OrganizationOwner",
  TeamMember = "TeamMember",
  Employee = "Employee",
}
